export default __webpack_public_path__ + "static/media/switch-icon-hover.ed59c367.svg";